import React from 'react';
import './TextAnswerResults.scss';

import Scrollable from '../../../../elements/Scrollable';
import Screen from '../../../Screen';
import QuestionHeader from '../../common/QuestionHeader/QuestionHeader';
import VoteAgain from '../../common/VoteAgain/VoteAgain';

export default class TextAnswerResults extends React.Component {
    render() {
        const {event, question, results} = this.props,
            header = <QuestionHeader {...this.props} />,
            footer = <VoteAgain {...this.props} />,
            normalStyle = {},
            favoriteStyle = {borderColor: event.settings.secondary_color};

        return (
            <Screen className="LiveVoting TextAnswerResults" header={header} footer={footer}>
                <Scrollable>
                    <ul className="content">
                        {results.map((answer, i) => (
                            <li key={i} className={answer.favorite ? 'favorite' : ''} style={answer.favorite ? favoriteStyle : normalStyle}>
                                {answer.value}
                            </li>
                        ))}
                    </ul>
                </Scrollable>
            </Screen>
        );
    }
}
